import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  fill: "none",
  viewBox: "0 0 18 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#a)" }, [
      _createElementVNode("path", {
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "1.5",
        d: "m13.547 6.375-9.094 5.25m9.094-5.25.823-3.074m-.823 3.074 3.073.824M4.453 11.625l-3.073-.824m3.073.824-.823 3.074m9.917-3.074-9.094-5.25m9.094 5.25 3.073-.824m-3.073.824.823 3.073M4.453 6.375 3.63 3.302m.823 3.073-3.073.824M9 3.75v10.5m0-10.5L6.75 1.5M9 3.75l2.25-2.25M9 14.25 6.75 16.5M9 14.25l2.25 2.25"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 0h18v18H0z"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }